import { useState } from "react"
import ChevronDownIcon from "../../../img/svg/chevronDownIcon";

export default function ExpandableFilter({ name, children }: { name: string, children: React.ReactNode }) {

    const [expanded, setExpanded] = useState(false);

    return (
        <div className={`transition-all duration-300 border-b border-surface last:border-0 ${expanded ? "pb-4" : "pb-0"}`}>
            <button 
                onClick={() => setExpanded(!expanded)} 
                className="w-full flex justify-between items-center py-4 text-xs font-black tracking-widest text-primary uppercase hover:text-secondary transition-colors"
            >
                <span>{name}</span>
                <div className={`transition-transform duration-500 ${expanded ? "rotate-180 text-secondary" : "text-mono"}`}>
                    <ChevronDownIcon width="16px" fill="currentColor" />
                </div>
            </button>
            <div className={`overflow-hidden transition-all duration-500 ease-in-out ${expanded ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}`}>
                <div className="pt-2 pb-2 space-y-3">
                    {children}
                </div>
            </div>
        </div>
    )
}